import { useMemo } from 'react'

let TASK_BOARD_LIST_TYPES = [
  {
    id: 'my-boards',
  },
  {
    id: 'other-boards',
  },
  {
    id: 'private',
  },
]

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return {
      ...data,
      type: TASK_BOARD_LIST_TYPES.find(i => i.id === props.type).id,
      collapse: props?.collapse || false,
      iconOnly: props?.iconOnly || false,
      showPrivateIcon: props?.showPrivateIcon || false,
    }
  }, [props.type]) // eslint-disable-line
}
